export default __webpack_public_path__ + "static/media/Moonspill.abf2e852.jpg";